import { jsx as _jsx } from "react/jsx-runtime";
import { getFlexProp, getGapPropKey } from './FlexContainer';
import { ScreenSize, useScreenSize } from '../util/MediaQueries';
import { NoPassiveDiv } from './NoPassiveDiv';
export const VisualContainer = (props) => {
    var _a;
    const { children, padding, width, height, justifyContent = 'left', style } = props;
    const screenSize = useScreenSize();
    const backgroundColor = '#FFFFFF99';
    const borderColor = '#FFFFFF';
    const borderWidth = screenSize === ScreenSize.Large ? '5px' : '3px';
    const borderStyle = 'solid';
    const borderRadius = screenSize === ScreenSize.Large ? '20px' : '12px';
    const flexProp = getFlexProp(props.flex);
    const gapPropKey = getGapPropKey((_a = props.horizontal) !== null && _a !== void 0 ? _a : false);
    return (_jsx(NoPassiveDiv, Object.assign({}, props.divProps, { style: Object.assign({ boxSizing: 'border-box', [gapPropKey]: props.gap, backgroundColor, borderWidth, borderColor, borderStyle, borderRadius, padding, flex: flexProp, width, height, display: 'flex', justifyContent, flexDirection: props.horizontal ? 'row' : 'column' }, style), children: children })));
};
//# sourceMappingURL=VisualContainer.js.map